import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Router } from '@angular/router';
import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { IntegracionServices } from "src/app/core/services/integraciones.service";
import { FileUploadComponent } from 'src/app/shared/components/file-upload/file-upload.component';
import { ServicioModel } from "src/app/models/Servicio.model";
import { lastValueFrom, takeUntil, Subject } from "rxjs";
import Swal, { SweetAlertIcon } from 'sweetalert2';

import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import { k } from "src/environments/properties";


@Component({
    selector: 'app-archivo-configuracion',
    templateUrl: './archivo-configuracion.component.html',
    styleUrls: ['./archivo-configuracion.css']
})
export class ArchivoConfiguracionComponent implements OnInit {

    selectedFiles: File | File[] | FileList | null = null;
    private destroy$ = new Subject<void>();
    public closeResult: string = '';
    spinner: boolean = false;
    toast = Swal;
    idServicio: string = '';
    estadoServicioExterno: boolean = false;
    nombreCortoServicio: string = '';
    nombreArchivo: string = '';
    public maxFile = 1;
    public maxFileSize = 10;
    public multiple = false;
    archivo: boolean = false;
    codigo = '';
    respuestaConexion: any;
    mostrarDetalle: boolean = false;
    baseUrl: string = '';

    tiempoConexion: number = 0;

    editorOptions = {
        theme: 'vs-dark',
        language: 'javascript',
        automaticLayout: true,
        minimap: {
            enabled: true
        }
    };

    // Definición de las acciones personalizadas
    customActions: TableAction[] = [];

    
    @ViewChild('modalResultadoConexion') ResultadoConexionModal!: TemplateRef<any>;
    @ViewChild('fileUpload', { static: false }) fileUploadComponent?: FileUploadComponent;


    constructor(
        private seriviciosServices: ServiciosService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        private integracionServices: IntegracionServices,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    async ngOnInit() {

        this.toastAlert();
        this.route.paramMap
            .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
            .subscribe(async params => {
                
                const id = params.get('id');

                if (id) {
                    this.openArchivo(id)
                }
            });
    }

    ngAfterViewInit(): void {

    }

    async openArchivo(id: string) {
        this.idServicio = id;
        this.showArchivo();
        this.estadoServicio();
    }

   
    async showArchivo() {
        const response = await lastValueFrom(this.seriviciosServices.showArchivo(this.idServicio));
        let url = response?.body?.url_documento;
        this.selectedFiles = [];
        if (url != null) {

            this.archivo = true;
            const contenido = this.base64ToString(url);
            this.codigo = contenido;
        } else {

            this.codigo = '';
            this.archivo = false;
        }

    }

    base64ToString(base64: string): string {
        const bytes = Uint8Array.from(
            atob(base64),
            c => c.charCodeAt(0)
        );

        return new TextDecoder('utf-8').decode(bytes);
    }

    async cambioEstado(estado: string, id: string) {

        const body = {
            "nombre_corto": estado
        }
        const response = await lastValueFrom(this.seriviciosServices.estadoServicio(body, id));
    }


    handleFiles(file: File) {

        this.selectedFiles = file;

    }

    async subirDocumentos(): Promise<boolean> {

        if (this.codigo) {
            this.selectedFiles = new File(
                [this.codigo],
                'config.js', // Ej: config.js
                {
                    type: 'text/javascript'
                }
            );
        }
        let files: File[] =
            this.selectedFiles instanceof File
                ? [this.selectedFiles]
                : Array.isArray(this.selectedFiles)
                    ? this.selectedFiles
                    : this.selectedFiles
                        ? Array.from(this.selectedFiles as FileList)
                        : [];

        // 1️⃣ Si hay archivos → SIEMPRE subir
        if (files.length > 0) {

            try {
                const formData = new FormData();
                files.forEach(f => formData.append('file', f, f.name));
                await lastValueFrom(
                    this.seriviciosServices.addArchivo(this.idServicio, formData)
                );
                this.alert('success', 'Documento cargado correctamente');
                this.fileUploadComponent?.clearFiles();
                this.selectedFiles = [];
                if (!this.estadoServicioExterno) {
                    this.cambioEstado('PPC', this.idServicio);
                }

                if (!this.codigo) {
                    this.modalService.dismissAll();
                }


            } catch (error) {
                console.error(error);
                this.alert('error', 'Error al subir documentos');
                return false;
            }
        } else {
            this.alert('warning', 'Coloca un archivo js para realizar la configuración.');
        }


        return true;
    }

    async pruebaConexion() {

        const { resultado, tiempo } = await this.medirTiempo(async () => {
            return await lastValueFrom(
                this.integracionServices.pruebaConexion(this.nombreCortoServicio)
            );
        });

        this.tiempoConexion = tiempo;
        this.mostrarDetalle = false;
        if (resultado) {
            this.respuestaConexion = resultado;
            this.openModalContent(this.ResultadoConexionModal, false, 'lg', 'modal-conexion');
        }

    }

    async medirTiempo<T>(callback: () => Promise<T>): Promise<{ resultado: T; tiempo: number }> {
        const inicio = performance.now();

        const resultado = await callback();

        const tiempo = Math.round(performance.now() - inicio);

        return {
            resultado,
            tiempo
        };
    }

    async estadoServicio() {
        const response = await lastValueFrom(this.seriviciosServices.showServicios(this.idServicio));
        const servicio = response.body;
        this.estadoServicioExterno = servicio?.id_estado != 11 ? false : true;
        this.nombreCortoServicio = servicio?.nombre_corto ?? '';
        this.baseUrl = servicio?.baseUrl ?? '';
        this.nombreArchivo = this.nombreCortoServicio ? this.nombreCortoServicio.toLowerCase() + '.config.js' : '';
    }

    openModalContent(
        content: any,
        mode: boolean,
        size: 'sm' | 'lg' | 'xl' = 'lg',
        windowClass?: string
    ) {

        this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            size,
            centered: true,
            windowClass
        }).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }



    toggleDetalle(): void {
        this.mostrarDetalle = !this.mostrarDetalle;
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string, text: string = '') {
        this.toast.fire({
            icon: icontext,
            title: title,
            text: text
        });
    }


}